<template>
    <Popper
        placement="top"
        :disabled="!moreInfo"
        :teleport-props="isCarousel ? { to: 'body' } : undefined"
        :transition-props="{ name: 'fade' }"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :modifiers="modifiers"
        hover
        arrow
    >
        <template #content>
            <RecommendTooltip v-if="isShow && moreInfo" :product-rating="productRating" :product-id="productId" :url-rating="productUrl" />
        </template>

        <div class="rating" :class="[`rating--${size}`, { 'rating--box': box, 'rating--all-stars': allStars }]" @mouseover="isShow = true">
            <span v-if="prefix" class="prefix">{{ prefix }}</span>
            <span
                class="rating__item"
                :class="{
                    'rating__item--box': box,
                }"
            >
                <span class="rating__item__skeleton" :style="`width: ${Math.round(Math.min(100, Math.max(0, rating * 20)))}%`"> </span>
            </span>

            <div v-if="totalText || total" class="rating__item__total" :class="{ 'rating__item__total--box': box }">
                <template v-if="totalText"> {{ totalText }} ({{ $numberFormat(total) }}) </template>
                <template v-else-if="total > 0"> {{ $numberFormat(rating) }} / {{ $numberFormat(total) }}x </template>
            </div>
        </div>
    </Popper>
</template>

<script lang="ts">
import Popper from 'vue3-popper'
import RecommendTooltip from '~/components/elements/RecommendTooltip.vue'

export default {
    components: {
        RecommendTooltip,
        Popper,
    },
    props: {
        rating: {
            type: Number,
            default: 0,
        },
        total: {
            type: Number,
            default: null,
        },
        totalText: {
            type: String,
            default: '',
        },
        moreInfo: {
            type: Boolean,
            default: false,
        },
        rateId: {
            type: Number,
            default: 0,
        },
        productId: {
            type: Number,
            default: 0,
        },
        productUrl: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'size-s',
        },
        box: {
            type: Boolean,
            default: false,
        },
        isCarousel: {
            type: Boolean,
            default: false,
        },
        productRating: {
            type: Object,
            default: null,
        },
        prefix: {
            type: String,
            default: '',
        },
        allStars: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isShow: false,
            modifiers: [
                {
                    name: 'eventListeners',
                    options: {
                        scroll: false,
                        resize: true,
                    },
                },
            ],
        }
    },
}
</script>

<style lang="scss" scoped>
$size-s: 12px;
$size-l: 14px;
$size-xl: 16px;
.rating {
    display: inline-flex;
    gap: 2px;
    justify-content: space-between;

    .prefix {
        font-size: 12px;
        margin-right: 5px;
    }

    &--box {
        //background-color: $color-yellow-light;
        border-radius: 26px;
        //padding: 6px 12px;
    }

    &--size-s {
        .rating__item {
            width: #{$size-s * 5 + 8};
            height: #{$size-s};
            background-size: #{$size-s + 2} #{$size-s};

            @include screen-sm {
                width: #{$size-s * 5 + 8};
            }
        }

        .rating__item__skeleton {
            height: #{$size-s};
            background-size: #{$size-s + 2} #{$size-s};
        }
    }

    &--size-l {
        .rating__item {
            width: #{$size-l * 5 + 8};
            height: #{$size-l};
            background-size: #{$size-l + 2} #{$size-l};

            @include screen-sm {
                width: #{$size-l * 5 + 8};
            }
        }

        &.rating--all-stars {
            .rating__item {
                width: #{$size-l * 5 + 8};
            }
        }

        .rating__item__skeleton {
            height: #{$size-l};
            background-size: #{$size-l + 2} #{$size-l};
        }
    }

    &--size-xl {
        .rating__item {
            width: #{$size-xl * 5 + 8};
            height: #{$size-xl};
            background-size: #{$size-xl + 2} #{$size-xl};

            @include screen-sm {
                width: #{$size-xl * 5 + 8};
            }
        }

        .rating__item__skeleton {
            height: #{$size-xl};
            background-size: #{$size-xl + 2} #{$size-xl};
        }

        .rating__item__total {
            font-size: 14px;
            height: 16px;
            line-height: 16px;
        }
    }
}

.rating__item {
    background: url('/nuxt-assets/images/icons/star-deactivate-silver-with-gap.svg') repeat-x 0 0;
    display: block;

    &--box {
        background-image: url('/nuxt-assets/images/icons/star-deactivate-with-gap.svg');
    }
}

.rating__item__skeleton {
    height: 100%;
    display: block;
    background: url('/nuxt-assets/images/icons/star-activate-with-gap.svg') repeat-x 0 0;
}

.rating__item__total {
    color: $color-dark;
    height: 12px;
    line-height: 12px;
    font-size: 12px;
    margin-left: 3px;
    white-space: nowrap;
}
</style>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.popper {
    max-width: 240px !important;
}
</style>
